export const constants = {
  LOGIN_TOKEN: "token",
  REPORTEE_CAPITAL: ["Hr", "Ceo", "Zmv"],
  REPORTEE_FIXED_CONVERT: {
    head_of_hr: "Head of HR",
    head_of_marketing: "Head of Marketing",
  },
  PAGE_SIZE: 9,
  KPI_COLUMN_STORAGE_KEY: "kpi_column_config",
  OBJECTIVE_COLUMN_STORAGE_KEY: "objective_column_config",
};
